import { CSSProperties, forwardRef, PropsWithChildren, ReactNode, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

type IFramContainerImperativeHandleProps = PropsWithChildren<{
    head?: ReactNode,
    style?: CSSProperties
}>

export type IFrameContainerImperativeHandle = {
    print: typeof window.print,
    scrollToElement: (id: string) => void
}

const IFrameContainer = forwardRef<IFrameContainerImperativeHandle, IFramContainerImperativeHandleProps>(({ head, children, style }, ref) => {

    const iframeRef = useRef<HTMLIFrameElement>(null)
    const [headFragment, setHeadFragment] = useState<HTMLHeadElement | null>(null)
    const [bodyFragment, setBodyFragment] = useState<HTMLBodyElement | null>(null)

    useImperativeHandle(ref, () => {
        return {
            print: () => iframeRef.current?.contentWindow?.print(),
            scrollToElement: (id:string) => iframeRef.current?.contentWindow?.document.getElementById(id)?.scrollIntoView()
        }
    }, [])

    const populateIframe = useCallback(() => {
        const contentDocument = iframeRef.current!.contentDocument!;

        setBodyFragment(contentDocument.body as HTMLBodyElement)
        setHeadFragment(contentDocument.head)
    }, [])

    useEffect(() => {
        populateIframe()
    }, [])

    return <iframe onLoad={() => populateIframe()} style={style} ref={iframeRef}>
        {headFragment && createPortal(head, headFragment)}
        {bodyFragment && createPortal(children, bodyFragment)}
    </iframe>
})

export default IFrameContainer;
